import AppCatalog from "../../services/App/AppCatalog.js";

export default {
  Total: {
    Label: AppCatalog.Info.NettProfit,
    Type: AppCatalog.Field.Hpp.Type,
    Output: AppCatalog.Field.Hpp.Output,
    ReadOnly: true
  }
}